export default {
  app: {
    dashboard: 'Highlights',
    scenes: 'Scene details',
    title: 'Diakse',
    products: 'Product details',
    time: 'Behavior details',
    footer: '© Diakse 2018',
    survey: 'Survey details'
  },
  dashboard: {
    tooltips: {
      new: 'New',
      export: 'Export',
      edittab: 'Edit Tab',
      deletetab: 'Delete Tab',
      menuButton: 'More',
      drag: 'Drag',
      informations: 'Informations',
      close: 'Close'
    },
    dialogs: {
      edit: {
        title: 'Edit title',
        text: 'Title',
        description: 'Choose a new title for the tab.',
        cancel: 'Cancel',
        save: 'Save'
      },
      delete: {
        title: 'Are you sure?',
        description: 'You are about to delete this tab. This action cannot be undone.',
        cancel: 'No, nevermind',
        save: 'Yes'
      },
      editgraph: {
        title: 'Edit graph',
        description: 'Choose the new graph.',
        cancel: 'Cancel',
        save: 'Change'
      },
      addgraph: {
        title: 'Add graph',
        description: 'Choose the graph to add.',
        cancel: 'Cancel',
        save: 'Add'
      }
    },
    menu: {
      create: {
        addtab: 'Add tab',
        addgraph: 'Add graph'
      },
      graph: {
        openButton: 'Open',
        changeButton: 'Change'
      },
      export:{
        exportComport: 'Behaviour',
        exportSurvey: 'Survey',
      }
    },
    newTabTitle: 'New Dashboard'
  },
  charts: {
    clickedItems: {
      legend: 'Clicks on each button (WIP)',
      xaxis: 'Button',
      yaxis: 'Number of clicks'
    },
    timePerScene: {
      legend: 'Average time spent in each scene per visitor',
      xaxis: 'Scene',
      yaxis: 'Average time (in minutes)'
    },
    allClickedItems: {
      legend: 'Number of items clicked',
      xaxis: 'Item',
      yaxis: 'Number of clicks'
    },
    scenesPerSession: {
      legend: "Number of sessions where x scenes have been visited",
      xaxis: 'Number of scenes',
      yaxis: 'Number of sessions'
    },
    clicksPerSession: {
      legend: "Number of sessions where x items have been clicked",
      xaxis: 'Number of clicks',
      yaxis: 'Number of sessions'
    },
    visitorsPerHour: {
      legend: "Number of visitors per hour",
      xaxis: 'Hour',
      yaxis: 'Number of visitors'
    },
    numberOfPagesSeen: {
      legend: 'Number of pages seen per week',
      xaxis: 'Week',
      yaxis: 'Number of pages seen'
    },
    numberOfScenesVisited: {
      legend: 'Number of scenes visited',
      xaxis: 'Scene',
      yaxis: 'Number of scenes'
    },
    numberOfVisitors: {
      legend: 'Number of visitors per week',
      xaxis: 'Week',
      yaxis: 'Number of visitors'
    },
    numberOfProductsAddedToCart: {
      legend: 'Number of products added to the cart per week',
      xaxis: 'Week',
      yaxis: 'Number of products'
    },
    numberOfProductsConsulted: {
      legend: 'Number of products consulted per week',
      xaxis: 'Week',
      yaxis: 'Number of products'
    },
    numberOfVisits: {
      legend: 'Number of visits per week',
      xaxis: 'Week',
      yaxis: 'Number of visits'
    },
    ratingsPerSession: {
      legend: 'Overview of Ratings Per Session',
      xaxis: 'Week',
      yaxis: 'Ratings Overview'
    },
    meanRatingsPerPeriod: {
      legend: 'Weekly average ratings',
      xaxis: 'Periode',
      yaxis: ' Average ratings'
    },
    numberOfVisitsFromSeat: {
      legend: 'Number of visits coming from a VR seat per week',
      xaxis: 'Week',
      yaxis: 'Number of visits'
    },
    nbClicks: {
      legend: 'Cumulated number of clicks',
      xaxis: 'Button',
      yaxis: 'Number of clicks'
    },
    nbProductsAddedToCart: {
      legend: 'Products added to cart',
      xaxis: 'Products',
      yaxis: 'Times added to cart'
    },
    visitsPerHour: {
      legend: 'Visits per hour of the day',
      xaxis: 'Hour of the day',
      yaxis: 'Number of visits'
    },
    clickedItemsPerType: {
      legend: 'Clicked buttons grouped by category (WIP)',
      xaxis: 'Button Name',
      yaxis: 'Number of clicks'
    },
    maxSessionLength: {
      legend: 'Sessions sorted per time spent',
      xaxis: 'Sessions',
      yaxis: 'Time spent'
    },
    meanSessionLength: {
      legend: 'Mean length of the sessions per week',
      xaxis: 'Week',
      yaxis: 'Mean length (in minutes)'
    },
    meanSessionsPerWeek: {
      legend: 'Mean number of sessions per week',
      xaxis: 'Weeks',
      yaxis: 'Sessions'
    },
    scenesViewedPerSession: {
      legend: 'Scenes viewed per session',
      xaxis: 'Number of scenes',
      yaxis: 'Number of sessions'
    },
    heatmap: {
      legend: 'Heatmap (WIP)'
    },
    itemsInScene: {
      legend: 'Items clicked in a determined scene',
      xaxis: 'Item',
      yaxis: 'Number of clicks'
    },
    surveyAnswers: {
      legend: 'Answers to selected questions'
    },
    timeRange: 'Time range',
    globalAverage: 'Global average',
    weightedAverage: 'Weighted average',
    totalValue: 'Total',
    median: 'Median',
    totalusers: 'Total number of users',
    totalcount: 'Total',
    clicks: 'clicks',
    timeformat: '12',
    All: 'All',
    Direct: 'Direct',
    Carousels: 'Carousels'
  },
  datePicker: {
    pick: 'Pick a date range',
    from: 'From:',
    to: 'To:',
    preset: 'Preset',
    today: 'Today',
    lastweek: 'Last week',
    last30days: 'Last 30 days',
    lastyear: 'Last year',
    startDate: 'Start Date ',
    endDate: 'End Date ',
    dateFormat: 'MM/DD/YYYY',
    locale: 'en',
    alltime: 'The last month',
    firstdayofweek: '0'
  },
  info: {
    dashboard: {
      title: 'First Steps - Dashboard',
      content: {
        '1': `Welcome on your data tracking App.`,
        '2': `Here, you can access all of your stores' data. We have put at your disposal several Dashboards to guide you through your objective.
        You can create your own custom Dashboard or add a graph in the current Dashboard with the + icon on top-left.`,
        '3': `
        You can resize, move, close or add a new graph. The "Change" button allows you to change the graph. 
        You can change the date range of your graphs by clicking on the dedicated button under the graphs: the default date range is the last month.
        You can also choose to see only the statistics coming from the carousels or directly from your website.`
      }
    },
    scenes: {
      title: 'First Steps - Scenes',
      content: {
        '1': `You are on the 'Scenes details' tab, where you can visualize detialed Data about scenes.`,
        '2': `To change graphs, you can click on the wanted graph's name on the Black bar at the center. Some of them will require you to select
        a specific scene, a tab will apprear on the right for you to select the scene you wish.`
      }
    },
    products: {
      title: 'First Steps - Products',
      content: {
        '1': `You are on the 'Products details' tab, where you can visualize detialed Data about Products.`,
        '2': `To change graphs, you can click on the wanted graph's name on the Black bar at the center. Some of them will require you to select
        a specific Prodcut, a tab will apprear on the right for you to select the Product you wish.`
      }
    },
    time: {
      title: 'First Steps - Behavior',
      content: {
        '1': `You are on the 'Behavior' tab, where you can visualize detialed Data about You client's behaviors, like
        Ratings, VR Mask use ratio, replays, and much more.`,
        '2': `To change graphs, you can click on the wanted graph's name on the Black bar at the center. Some of them will require you to select
        a specific hour, a tab will apprear on the right for you to select the hour you wish.`
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/i18n/langEn.js